export default __webpack_public_path__ + "static/media/default_avatar.09fc1519.jpg";